module.exports = __webpack_public_path__ + "static/media/3-item-c.ec8fea6c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/men/3-item-c.jpg
// module id = 1164
// module chunks = 33